export const AUTH_LOGIN_ENDPOINT = '/Auth/token?api-version=1.0';
export const AUTH_REFRESH_TOKEN_ENDPOINT = '/Auth/Refresh';
export const AUTH_ENTRA_LOGIN_ENDPOINT = '/Auth/EntraLogin';
export const AUTH_GET_SCOPES_ENDPOINT = '/Auth/GetScopes';
export const AUTH_CHANGE_PASSWORD_ENDPOINT = '/Auth/ChangePassword';
export const AUTH_CHANGE_PASSWORD_ON_FIRST_LOGIN_ENDPOINT = '/Auth/ChangePasswordOnFirstLogin';
export const SUBSCRIPTION_PLAN_ENDPOINT = '/Auth/SubscriptionPlan';
export const SUBSCRIPTION_CREATE_ENDPOINT = '/Auth/Subscription/Create';
/** Scheme name for external session token in Authorization header */
export const EXTERNAL_SESSION_AUTH_SCHEME = 'ExternalSession';
export const SUBSCRIPTION_EXTERNAL_PROVIDER_INITIALIZE_ENDPOINT = '/Auth/ExternalProvider/Initialize';
export const SUBSCRIPTION_EXTERNAL_PROVIDER_REGISTER_FIRST_ACTIVITY_ENDPOINT =
  '/Auth/ExternalProvider/RegisterFirstActivity';
export const SUBSCRIPTION_CREATE_WITH_PAYMENT_ENDPOINT = '/Subscription/CreateWithPayment';
export const SUBSCRIPTION_UPDATE_AUTORENEW_ENDPOINT = '/Subscription/UpdateAutoRenew';
/** External session auth; skip Bearer in token interceptor (hosted checkout + polling). */
export const PAYMENTS_TWOCHECKOUT_INITIATE_PATH = '/payments/2checkout/initiate';
export const PAYMENTS_TWOCHECKOUT_STATUS_PATH_PREFIX = '/payments/2checkout/status/';
export const GEN_OBJECT_ENDPOINT = '/GenObject';
export const SUBSCRIPTION_CREATE_PENDING_FOR_QR_ENDPOINT = '/Subscription/CreatePendingForQr';
export const SUBSCRIPTION_CONFIRM_QR_PAYMENT_ENDPOINT = '/Subscription/ConfirmQrPayment';
export const SUBSCRIPTION_CHECK_QR_PAYMENT_STATUS_ENDPOINT = '/Subscription/CheckQrPaymentStatus';
export const SUBSCRIPTION_CONFIRM_EPOSTA_REDIRECT_PAYMENT_ENDPOINT = '/Subscription/ConfirmEpostaRedirectPayment';
export const SUBSCRIPTION_FAIL_EPOSTA_REDIRECT_PAYMENT_ENDPOINT = '/Subscription/FailEpostaRedirectPayment';
export const EPOSTA_WALLET_HISTORY_ENDPOINT = '/Payment/wallet-history';
export const CONTRACT_GENERATE_ENDPOINT = '/Contract/generate';
export const CONTRACT_BY_NIPT_ENDPOINT = '/Contract/by-nipt';
export const CONTRACT_BY_PAYMENT_ENDPOINT = '/Contract/by-payment';

